import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Dropdown, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../../common/actions';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {pageSizes} from '../../../common/constants/lists';
import {
  dateFormatShow,
  fullHourFormat,
} from '../../../common/constants/datesFormat';
import TablePaginator from '../../../common/components/tablePaginator';

class TableRecords extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  getMoneyValue(value = 0) {
    return `$${getNumericValue(value, 2)}`;
  }

  onPageSizeClick(event, data) {
    this.props.changePartsListPageSize(data.value);
    this.props.getKardex(0, data.value);
  }

  onPageClick(value) {
    this.props.changePartsListPage(value);
    this.props.onSearch(value);
  }

  renderItems() {
    const {lineItems} = this.props;

    if (!lineItems.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={15}>
            No hay Datos Disponibles
          </Table.Cell>
        </Table.Row>
      );
    }
    return lineItems.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>
            {element.date ? moment(element.date).format(dateFormatShow) : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.date ? moment(element.date).format(fullHourFormat) : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.documentType}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.transactionDetail}
          </Table.Cell>
          <Table.Cell textAlign='right'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.finalBalance}</Table.Cell>
          <Table.Cell textAlign='right'>
            {this.getMoneyValue(element.unitCost)}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {this.getMoneyValue(element.extendedCost)}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.orderType}</Table.Cell>
          <Table.Cell textAlign='center'>{element.documentNumber}</Table.Cell>
          <Table.Cell textAlign='center'>{element.fiscalNumber}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.clientProviderCode}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.clientProviderName}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.agency} - {element.agencyName}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.user}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }

  renderHeader() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Hora</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Tipo doc</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Transacción</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Saldo Final</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Valor Unitario</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Valor Total</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Tipo</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Orden</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Fiscal</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Proveedor - Cliente
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  renderFooter() {
    const {pageNumber, pageSize, lineItemsCount} = this.props;

    if (!(lineItemsCount <= pageSize)) {
      return (
        <Table.Footer>
          <Table.Row textAlign='center'>
            <Table.HeaderCell colSpan='100%'>
              <div className='table-pagination'>
                <span className='page-sizer'>
                  <strong>Items por página</strong>
                  <Dropdown
                    selection
                    upward
                    compact
                    value={pageSize}
                    options={pageSizes}
                    onChange={this.onPageSizeClick}
                  />
                </span>
                <TablePaginator
                  itemsCount={lineItemsCount}
                  itemsPerPage={pageSize}
                  selectedPage={pageNumber}
                  onOptionClick={this.onPageClick}
                />
              </div>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      );
    }
  }

  render() {
    return (
      <Table striped className='toyota-grid'>
        {this.renderHeader()}
        <Table.Body>{this.renderData()}</Table.Body>
        {this.renderFooter()}
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'partData': state.kardex.partData,
    'loading': state.kardex.loading,
    'lineItems': state.kardex.page,
    'pageNumber': state.kardex.pageNumber,
    'pageSize': state.kardex.pageSize,
    'lineItemsCount': state.kardex.itemsCount,
  };
};

const {
  fetchPart,
  fetchKardex,
  changePartsListPage,
  changePartsListPageSize,
  fetchWarehouses,
} = Actions;

export default connect(mapStateToProps, {
  fetchPart,
  fetchKardex,
  changePartsListPage,
  changePartsListPageSize,
  fetchWarehouses,
})(TableRecords);
